module.exports = __webpack_public_path__ + "img/svea_christiansen_preview.be2536f2.png";